import { File02Icon } from '@/components/icons/File02Icon';
import { SearchFilterToolbar } from '@/components/tables/DataTable/components/SearchFilterToolbar';
import { FilterGroup } from '@/components/tables/TableFilter/types';

import { DOCUMENT_TYPE_OPTIONS } from '../../documents.constants';
import { useDocumentsTableContext } from '../context/DocumentsTable.context';

export function DocumentsSearchFilterToolbar() {
  const { filterValue, setFilterValue } = useDocumentsTableContext();

  const documentTypeOptions = DOCUMENT_TYPE_OPTIONS.filter(
    (d) => !d.disabled
  ).map((opt) => ({
    value: opt.value,
    label: opt.display,
  }));

  const filterGroups: FilterGroup[] = [
    {
      id: 'documentType',
      label: 'Document type',
      icon: <File02Icon size={18} />,
      multi: true,
      options: documentTypeOptions,
    },
  ];

  return (
    <SearchFilterToolbar
      searchProps={{
        placeholder: 'Search documents',
      }}
      tableFilterProps={{
        groups: filterGroups,
        value: filterValue,
        onChange: setFilterValue as (value: Record<string, string[]>) => void,
      }}
    />
  );
}
